import { CommonModule, CurrencyPipe, DatePipe, NgForOf } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { ContentCardModule } from '../../../../../../@itc-core/components/components/content-card/common/content-card.module';
import { ItcBusyModule } from '../../../../../../@itc-core/directives/itc-busy/component/itc-busy.module';
import { SlideOverComponent } from '../../../../../../@mos-core/components/slide-over/slide-over.component';
import { PipeExportModule } from '../../../../../helpers/pipe-export.module';
import { SendEmailFormComponent } from './send-email-form.component';
import { ExportTabsService } from '../export-tabs/common/export-tabs.service';

@NgModule({
	declarations: [SendEmailFormComponent],
	imports: [CommonModule, NgForOf, ReactiveFormsModule, CurrencyPipe, FormsModule, NgSelectModule, ContentCardModule, TabsModule, ItcBusyModule, SlideOverComponent, PipeExportModule],
	providers: [ExportTabsService],
	exports: [SendEmailFormComponent],
})
export class SendEmailFormModule {}
